<template>
  <div class="ImageUploader">
    <h3>图片预览:</h3>
    <div id="htmlContent" ref="htmlContent">
      <img v-if="imageUrl" :src="imageUrl" alt="Image" style="max-width: 100%; height: auto" />
    </div>
    <input type="file" @change="onFileChange" accept="image/*" />
    <el-button @click="generateImage">生成图片并下载</el-button>
  </div>
</template>

<script>
import html2canvas from "html2canvas";

export default {
  data() {
    return {
      imageUrl: null,
      imageFile: null,
    };
  },
  methods: {
    onFileChange(event) {
      const file = event.target.files[0];
      if (file && file.type.startsWith("image/")) {
        this.imageFile = file;
        this.imageUrl = URL.createObjectURL(file);
      } else {
        alert("请选择一个有效的图片文件");
      }
    },
    generateImage() {
      const htmlContent = this.$refs.htmlContent;

      html2canvas(htmlContent).then(canvas => {
        canvas.toBlob(blob => {
          const link = document.createElement("a");
          link.href = URL.createObjectURL(blob);
          link.download = "generated-image.png";
          link.click();
        }, "image/png");
      });
    },
  },
};
</script>

<style>
.ImageUploader {
  #htmlContent {
    max-width: 100%;
    height: auto;
    width: 450px;
    height: 900px;
    background-color: white;
    display: flex; /* 使用Flexbox布局 */
    justify-content: center; /* 水平居中 */
    align-items: center; /* 垂直居中 */

    img {
      max-width: 100%;
      height: auto;
    }
  }
}
</style>
